import styles from './DatePickerCalendar.module.css'
import { moment, isToday, isSameDay } from '../utils/dateUtils'

export default function DatePickerCalendar({ 
    monthDate, 
    calendarId, 
    dateRange, 
    onDateClick, 
    onNavigateMonth 
}) {
    // Calendar utility functions
    const getDaysInMonth = (date) => {
        return moment(date).daysInMonth()
    }

    const getFirstDayOfMonth = (date) => {
        return moment(date).startOf('month').day()
    }

    const getMonthName = (date) => {
        return moment(date).format('MMMM YYYY')
    }

    const isDateInRange = (date) => {
        if (!dateRange.from || !dateRange.to) return false
        const dateStr = moment(date).format('YYYY-MM-DD')
        return dateStr >= dateRange.from && dateStr <= dateRange.to
    }

    const isDateSelected = (date) => {
        const dateStr = moment(date).format('YYYY-MM-DD')
        return dateStr === dateRange.from || dateStr === dateRange.to
    }

    const daysInMonth = getDaysInMonth(monthDate)
    const firstDayOfMonth = getFirstDayOfMonth(monthDate)
    const days = []
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDayOfMonth; i++) {
        days.push(<div key={`empty-${i}`} className={styles.calendarDayEmpty}></div>)
    }
    
    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(monthDate.getFullYear(), monthDate.getMonth(), day)
        const isSelected = isDateSelected(date)
        const isInRange = isDateInRange(date)
        const isToday = date.toDateString() === new Date().toDateString()
        
        days.push(
            <button
                key={day}
                className={`${styles.calendarDay} ${isSelected ? styles.selected : ''} ${isInRange ? styles.inRange : ''} ${isToday ? styles.today : ''}`}
                onClick={() => onDateClick(date)}
            >
                {day}
            </button>
        )
    }

    return (
        <div className={styles.miniCalendar}>
            <div className={styles.calendarHeader}>
                <button 
                    className={styles.calendarNavButton}
                    onClick={() => onNavigateMonth(-1, calendarId)}
                >
                    ‹
                </button>
                <span className={styles.calendarMonthTitle}>{getMonthName(monthDate)}</span>
                <button 
                    className={styles.calendarNavButton}
                    onClick={() => onNavigateMonth(1, calendarId)}
                >
                    ›
                </button>
            </div>
            <div className={styles.calendarWeekdays}>
                {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
                    <div key={day} className={styles.calendarWeekday}>{day}</div>
                ))}
            </div>
            <div className={styles.calendarGrid}>
                {days}
            </div>
        </div>
    )
}